import { reCreateGroupMenu } from './template.js';
import './init_glob.js';
import './porevit.js';
import './accordion.js';
import './new_project.js';
import './screenshot.js';
import './spreadsheet.js';
import './house_configurate.js';
import './view.js';
import './modals.js';
import './cart.js';
import './save.js';
import './fence_configurate.js';
import './mobile.js';
import { validateForm } from './sendMail.js';
import { closeModal } from './modals.js';
import { make_pdf } from './pdf/create_pdf.js';
import { servObj } from './init_glob.js';
import { onResize } from './resize.js';
import { gsap } from 'gsap';

const btnsBack = document.querySelectorAll('.btn_back');
const radioButtons = document.querySelectorAll('input[type="radio"][name="paving-slabs"]');
const infoToggler = document.getElementById('info-toggler');
const rightPanelToggler = document.getElementById('right-panel__toggler');
const rightPanelCloser = document.getElementById('right-panel__closer');
const mobileSettingsOpener = document.getElementById('mobile-settings-opener');

btnsBack.forEach((el) => {
    el.addEventListener('pointerdown', () => {
        document.getElementById('menu_selected-slabs').style = 'display: none';
        document.getElementById('menu_selected-fence').style = 'display: none';
        document.getElementById('menu_main').style = 'display: flex';
        document.querySelector('.info-window').style.display = 'none';
    });
});

radioButtons.forEach((radioButton) => {
    radioButton.addEventListener('click', function () {
        document.getElementById('menu_selected-slabs').style = 'display: flex';
        document.getElementById('menu_main').style = 'display: none';
        //document.querySelector('.info-window').style.display = 'block';

        document.querySelector('#menu_selected-slabs .scroll-content').scrollTop = 0;

        //if (this.checked) {
        //    console.log(`Выбран radio button со значением: ${this.value}`);

        reCreateGroupMenu(this.value.split('__')[1]);
        //}
    });
});

document.querySelector('#fence-block-button').addEventListener('pointerdown', () => {
    document.getElementById('menu_selected-fence').style = 'display: flex';
    document.getElementById('menu_main').style = 'display: none';
});

servObj.isInfoWindowHide = false;

infoToggler.addEventListener('pointerdown', () => {
    const infoWindow = document.querySelector('.info-window');

    //infoWindow.classList.toggle('hide');

    //const isHide = infoWindow.classList.contains('hide');
    servObj.isInfoWindowHide = !servObj.isInfoWindowHide;

    gsap.to(infoWindow, {
        duration: 0.3,
        ease: 'steps(1000)',
        right: `${servObj.isInfoWindowHide ? 'calc(100% - 272rem)' : 'calc(100% + 20rem)'}`,
    });

    infoToggler.innerHTML = servObj.isInfoWindowHide
        ? `<img src="./images/icons/eye.svg" alt="Открыть" />`
        : `<img src="./images/icons/eye-slash.svg" alt="Закрыть" />`;
});

// Подставка имени файла для кастомного <input type="file" />
document.getElementById('file').addEventListener('change', function () {
    const fileInputBlock = document.querySelector('.file-upload');
    const fileNameText = fileInputBlock.querySelector('.file-name');

    const file = this.files[0];
    if (!file) {
        fileNameText.textContent = 'Файл не выбран';
        return;
    }

    const isJsonType = file.type === 'application/json';
    const isJsonExtension = file.name.toLowerCase().endsWith('.json');

    const fileName = this.files[0]?.name || 'Файл не выбран';

    if (isJsonType && isJsonExtension) {
        fileNameText.textContent = fileName;
        fileNameText.classList.remove('input_error');
        fileInputBlock.classList.remove('input_error');
    } else {
        fileNameText.textContent = 'Формат только .json';
        fileNameText.classList.add('input_error');
        fileInputBlock.classList.add('input_error');
    }
});

document.getElementById('place-order-submit').addEventListener('pointerdown', () => {
    if (!validateForm()) {
        console.error('Форма не валидна!');
        return;
    }

    make_pdf();
    ym(53353909,'reachGoal','config');
    // const specData = createSpecData()
    // sendMail(specData)
    closeModal('place-order-modal');
});
document.querySelectorAll('.download-spec').forEach((btn) => {
    btn.addEventListener('pointerdown', () => {
        make_pdf(true);
    });
});

servObj.isMenuOpen = true;
const sidebar = document.querySelector('.right-panel');

export function toggleMenu(isOpen = null) {
    if (isOpen !== null && typeof isOpen === 'boolean') {
        servObj.isMenuOpen = isOpen;
    } else {
        servObj.isMenuOpen = !servObj.isMenuOpen;
    }

    rightPanelToggler.classList.toggle('hide', !servObj.isMenuOpen);
    rightPanelCloser.classList.toggle('hide', !servObj.isMenuOpen);
    sidebar.classList.toggle('open', servObj.isMenuOpen);

    let infoWindow = document.querySelector('.info-window');
    let container = document.querySelector('.d3d-container');
    let renderer = servObj.scene.activeRenderer;
    let annRenderer = servObj.scene.annRenderer;
    let camera = servObj.scene.activeCamera;

    if (!container || !renderer || !camera || !annRenderer) {
        console.log('not any object in toggleMenu()');
        return;
    }

    gsap.to(sidebar, {
        duration: 0.3,
        ease: 'steps(1000)',
        right: `${servObj.isMenuOpen ? '0' : '-405rem'}`,
        onUpdate() {
            let sidebarLeft = sidebar.getBoundingClientRect().left;

            if (!servObj.isInfoWindowHide) infoWindow.style.right = `calc(100% + 20rem + ${sidebar.style.right})`;
            if (servObj.isInfoWindowHide) infoWindow.style.right = `calc(100% - 272rem + ${sidebar.style.right})`;

            container.style.width = `calc(100vw - (405rem + ${sidebar.style.right}))`;
            //console.log(sidebar.getBoundingClientRect().left)
            document.querySelector('.bottom-panel').style.width = `calc(100% - 445rem - ${sidebar.style.right})`;

            onResize(renderer, camera, container);
            onResize(annRenderer, camera, container);
        },
    });
}

rightPanelToggler.addEventListener('pointerdown', () => {
    toggleMenu();
});

rightPanelCloser?.addEventListener('pointerup', () => {
    toggleMenu(false);
});

mobileSettingsOpener?.addEventListener('pointerup', () => {
    toggleMenu(true);
});

export const createResizeHandler = ({ delay = 100, breakpoint = 980 } = {}) => {
    let timeout;
    let previousMobileState;

    const checkAndToggleMenu = () => {
        const isMobile = document.documentElement.clientWidth < breakpoint;
        console.log({ isMobile });

        if (isMobile && previousMobileState !== isMobile) {
            toggleMenu(false);
        } else if (!isMobile && previousMobileState !== isMobile) {
            toggleMenu(true);
        }

        previousMobileState = isMobile;
    };

    return () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            requestAnimationFrame(checkAndToggleMenu);
        }, delay);
    };
};

export const resizeHandler = createResizeHandler();
